const WORKBENCH_SETTINGS = 'workbench:settings';

export { WORKBENCH_SETTINGS };
//# sourceMappingURL=metadata-keys.js.map
